import { Editor } from 'slate';

export default function getLastNode(editor, options) {
  const generator = Editor.nodes(editor, { reverse: true, ...options });
  const { value: nodeEntry, done } = generator.next();
  return done ? null : nodeEntry;
}
